// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-ManageBlackBox-Users-UsersTable-styles___pageHeaderWrapper--YIMYc {
  display: flex;
  justify-content: space-between;
}

.components-ManageBlackBox-Users-UsersTable-styles___bbusersTable--ptCF2 .components-ManageBlackBox-Users-UsersTable-styles___tableHead--DihJs {
    color: #1b2432 !important;
    font-size: 13px !important;
    letter-spacing: 0;
    line-height: 18px;
    font-weight: 600 !important;
    height: 60px !important;
  }

.components-ManageBlackBox-Users-UsersTable-styles___bbusersTable--ptCF2 .components-ManageBlackBox-Users-UsersTable-styles___tableRow--bj3wO:last-child .components-ManageBlackBox-Users-UsersTable-styles___tableRowCell--GfS5N {
        border-bottom: none;
      }

.components-ManageBlackBox-Users-UsersTable-styles___bbusersTable--ptCF2 .components-ManageBlackBox-Users-UsersTable-styles___tableRow--bj3wO:last-child td {
        border-bottom: none;
      }

.components-ManageBlackBox-Users-UsersTable-styles___bbusersTable--ptCF2 .components-ManageBlackBox-Users-UsersTable-styles___tableRow--bj3wO:hover {
      background: #f6f6f7;
    }

.components-ManageBlackBox-Users-UsersTable-styles___bbusersTable--ptCF2 .components-ManageBlackBox-Users-UsersTable-styles___paper--IZ_6a {
    position: relative;
  }

.components-ManageBlackBox-Users-UsersTable-styles___bbusersTable--ptCF2 .components-ManageBlackBox-Users-UsersTable-styles___tableRowCell--GfS5N {
    height: 65px !important;
    padding: 4px 24px 4px 24px !important;
    font-size: 15px !important;
    min-width: 140px !important;
    text-overflow: ellipsis;
    overflow: hidden;
    color: #1b2432;
  }

.components-ManageBlackBox-Users-UsersTable-styles___bbusersTable--ptCF2 .components-ManageBlackBox-Users-UsersTable-styles___tableRowCellEmail--z93YR {
    max-width: 300px !important;
  }

.components-ManageBlackBox-Users-UsersTable-styles___bbusersTable--ptCF2 .components-ManageBlackBox-Users-UsersTable-styles___tableRowCellRole--B6g5U::first-letter {
    text-transform: uppercase;
  }

.components-ManageBlackBox-Users-UsersTable-styles___bbusersTable--ptCF2 .components-ManageBlackBox-Users-UsersTable-styles___tableRowCellStatusActive--jFFLd {
    height: 32px;
    background: rgba(18, 218, 159, 0.1);
    border: 1px solid #12da9f;
    border-radius: 4px;
    font-family: 'Roboto';
    font-size: 13px;
    color: #1b2432;
    letter-spacing: 0;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    width: -moz-fit-content;
    width: fit-content;
    padding-left: 8px;
    padding-right: 8px;
  }

.components-ManageBlackBox-Users-UsersTable-styles___bbusersTable--ptCF2 .components-ManageBlackBox-Users-UsersTable-styles___tableRowCellStatusDisabled--m3FlC {
    font-family: 'Roboto';
    font-size: 13px;
    color: #1b2432;
    letter-spacing: 0;
    text-align: center;
    background: rgba(252, 59, 96, 0.1);
    border: 1px solid #fc3b60;
    border-radius: 4px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: -moz-fit-content;
    width: fit-content;
    padding-left: 8px;
    padding-right: 8px;
  }

.components-ManageBlackBox-Users-UsersTable-styles___bbusersTable--ptCF2 .components-ManageBlackBox-Users-UsersTable-styles___tableCellName--oqBZO {
    font-family: 'Roboto';
    font-size: 15px;
    color: #1b2432;
    letter-spacing: 0;
    font-weight: 600 !important;
  }

.components-ManageBlackBox-Users-UsersTable-styles___bbusersTable--ptCF2 .components-ManageBlackBox-Users-UsersTable-styles___tableHeadBoxShadow--Fe1QT {
    box-shadow: 0px 21px 13px -15px rgba(109, 113, 122, 0.15) !important;
  }

.components-ManageBlackBox-Users-UsersTable-styles___bbusersTable--ptCF2 .components-ManageBlackBox-Users-UsersTable-styles___cellHide--n2zDR {
    width: 30px;
    min-width: 0 !important;
    padding: 0 !important;
  }

.components-ManageBlackBox-Users-UsersTable-styles___bbusersTable--ptCF2 td:first-child {
    border-bottom: none;
  }

.components-ManageBlackBox-Users-UsersTable-styles___bbusersTable--ptCF2 td:nth-child(2) {
    padding-left: 0 !important;
  }

.components-ManageBlackBox-Users-UsersTable-styles___bbusersTable--ptCF2 th:nth-child(2) {
    padding-left: 0 !important;
  }

.components-ManageBlackBox-Users-UsersTable-styles___bbusersTable--ptCF2 td:last-child {
    border-bottom: none !important;
  }

.components-ManageBlackBox-Users-UsersTable-styles___bbusersTable--ptCF2 tr:last-child td {
    border-bottom: none !important;
  }

.components-ManageBlackBox-Users-UsersTable-styles___bbusersTable--ptCF2 .components-ManageBlackBox-Users-UsersTable-styles___editCell--bXg5M {
    text-align: end;
    cursor: pointer;
  }
`, "",{"version":3,"sources":["webpack://./components/ManageBlackBox/Users/UsersTable/styles.pcss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAGE;IACE,yBAAyB;IACzB,0BAA0B;IAC1B,iBAAiB;IACjB,iBAAiB;IACjB,2BAA2B;IAC3B,uBAAuB;EACzB;;AAII;QACE,mBAAmB;MACrB;;AACA;QACE,mBAAmB;MACrB;;AAGF;MACE,mBAAmB;IACrB;;AAGF;IACE,kBAAkB;EACpB;;AAEA;IACE,uBAAuB;IACvB,qCAAqC;IACrC,0BAA0B;IAC1B,2BAA2B;IAC3B,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;EAChB;;AAEA;IACE,2BAA2B;EAC7B;;AAEA;IACE,yBAAyB;EAC3B;;AAEA;IACE,YAAY;IACZ,mCAAmC;IACnC,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,uBAAkB;IAAlB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;;AAEA;IACE,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,kCAAkC;IAClC,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,uBAAkB;IAAlB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;;AAEA;IACE,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,2BAA2B;EAC7B;;AAEA;IACE,oEAAoE;EACtE;;AAEA;IACE,WAAW;IACX,uBAAuB;IACvB,qBAAqB;EACvB;;AAEA;IACE,mBAAmB;EACrB;;AAEA;IACE,0BAA0B;EAC5B;;AAEA;IACE,0BAA0B;EAC5B;;AAEA;IACE,8BAA8B;EAChC;;AAEA;IACE,8BAA8B;EAChC;;AAEA;IACE,eAAe;IACf,eAAe;EACjB","sourcesContent":[".pageHeaderWrapper {\n  display: flex;\n  justify-content: space-between;\n}\n\n.bbusersTable {\n  .tableHead {\n    color: #1b2432 !important;\n    font-size: 13px !important;\n    letter-spacing: 0;\n    line-height: 18px;\n    font-weight: 600 !important;\n    height: 60px !important;\n  }\n\n  .tableRow {\n    &:last-child {\n      .tableRowCell {\n        border-bottom: none;\n      }\n      td {\n        border-bottom: none;\n      }\n    }\n\n    &:hover {\n      background: #f6f6f7;\n    }\n  }\n\n  .paper {\n    position: relative;\n  }\n\n  .tableRowCell {\n    height: 65px !important;\n    padding: 4px 24px 4px 24px !important;\n    font-size: 15px !important;\n    min-width: 140px !important;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    color: #1b2432;\n  }\n\n  .tableRowCellEmail {\n    max-width: 300px !important;\n  }\n\n  .tableRowCellRole::first-letter {\n    text-transform: uppercase;\n  }\n\n  .tableRowCellStatusActive {\n    height: 32px;\n    background: rgba(18, 218, 159, 0.1);\n    border: 1px solid #12da9f;\n    border-radius: 4px;\n    font-family: 'Roboto';\n    font-size: 13px;\n    color: #1b2432;\n    letter-spacing: 0;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: fit-content;\n    padding-left: 8px;\n    padding-right: 8px;\n  }\n\n  .tableRowCellStatusDisabled {\n    font-family: 'Roboto';\n    font-size: 13px;\n    color: #1b2432;\n    letter-spacing: 0;\n    text-align: center;\n    background: rgba(252, 59, 96, 0.1);\n    border: 1px solid #fc3b60;\n    border-radius: 4px;\n    height: 32px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: fit-content;\n    padding-left: 8px;\n    padding-right: 8px;\n  }\n\n  .tableCellName {\n    font-family: 'Roboto';\n    font-size: 15px;\n    color: #1b2432;\n    letter-spacing: 0;\n    font-weight: 600 !important;\n  }\n\n  .tableHeadBoxShadow {\n    box-shadow: 0px 21px 13px -15px rgba(109, 113, 122, 0.15) !important;\n  }\n\n  .cellHide {\n    width: 30px;\n    min-width: 0 !important;\n    padding: 0 !important;\n  }\n\n  td:first-child {\n    border-bottom: none;\n  }\n\n  td:nth-child(2) {\n    padding-left: 0 !important;\n  }\n\n  th:nth-child(2) {\n    padding-left: 0 !important;\n  }\n\n  td:last-child {\n    border-bottom: none !important;\n  }\n\n  tr:last-child td {\n    border-bottom: none !important;\n  }\n\n  .editCell {\n    text-align: end;\n    cursor: pointer;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageHeaderWrapper": `components-ManageBlackBox-Users-UsersTable-styles___pageHeaderWrapper--YIMYc`,
	"bbusersTable": `components-ManageBlackBox-Users-UsersTable-styles___bbusersTable--ptCF2`,
	"tableHead": `components-ManageBlackBox-Users-UsersTable-styles___tableHead--DihJs`,
	"tableRow": `components-ManageBlackBox-Users-UsersTable-styles___tableRow--bj3wO`,
	"tableRowCell": `components-ManageBlackBox-Users-UsersTable-styles___tableRowCell--GfS5N`,
	"paper": `components-ManageBlackBox-Users-UsersTable-styles___paper--IZ_6a`,
	"tableRowCellEmail": `components-ManageBlackBox-Users-UsersTable-styles___tableRowCellEmail--z93YR`,
	"tableRowCellRole": `components-ManageBlackBox-Users-UsersTable-styles___tableRowCellRole--B6g5U`,
	"tableRowCellStatusActive": `components-ManageBlackBox-Users-UsersTable-styles___tableRowCellStatusActive--jFFLd`,
	"tableRowCellStatusDisabled": `components-ManageBlackBox-Users-UsersTable-styles___tableRowCellStatusDisabled--m3FlC`,
	"tableCellName": `components-ManageBlackBox-Users-UsersTable-styles___tableCellName--oqBZO`,
	"tableHeadBoxShadow": `components-ManageBlackBox-Users-UsersTable-styles___tableHeadBoxShadow--Fe1QT`,
	"cellHide": `components-ManageBlackBox-Users-UsersTable-styles___cellHide--n2zDR`,
	"editCell": `components-ManageBlackBox-Users-UsersTable-styles___editCell--bXg5M`
};
module.exports = ___CSS_LOADER_EXPORT___;
